import { createContext, useContext } from 'react'

type ScrollListener = (y: number) => void

interface ScrollContextType {
  scrollY: number
  isSmooth: boolean
  /**
   * Subscribe to frame-perfect scroll updates.
   * On desktop the callback fires synchronously inside the RAF tick so your
   * DOM writes land in the same browser paint as SmoothScroll's own transform.
   * Returns an unsubscribe function (suitable as a useEffect cleanup return).
   */
  subscribe: (cb: ScrollListener) => () => void
}

const noop = () => () => {}

export const ScrollContext = createContext<ScrollContextType>({
  scrollY: 0,
  isSmooth: false,
  subscribe: noop,
})

export const useScroll = () => useContext(ScrollContext)
